import img from '../images/clear-icon.svg';
import {useDispatch, useSelector} from "react-redux";
import {airtable_config_get_label, resetFilter} from "../redux/actions";

export const ResetFilter = () => {
    const dispatch = useDispatch()
    const search = useSelector(state => state.app.search)
    const current_category = useSelector(state => state.app.current_category)
    const mobile_tracking = useSelector(state => state.app.mobile_tracking)
    const exclusive = useSelector(state => state.app.exclusive)
    const hot_deal = useSelector(state => state.app.hot_deal)
    const airconfig = useSelector(state => state.app.airconfig)
    const app_lang = useSelector(state => state.app.app_lang)
    const handleBtnClick = () => {
        dispatch(resetFilter())
    }
    if (search.length > 0 || current_category !== '' || mobile_tracking || exclusive || hot_deal) {

        return (
            <div className="reset-filter">
                <div className="reset-filter__btn" onClick={() => handleBtnClick()}>
                    {airtable_config_get_label(airconfig, 'reset_filter_btn', app_lang)}
                    <img src={img} alt="" title=""/>
                </div>
            </div>
        )
    }
    return null;
}